import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ChevronRight, Title } from '../../components/shared';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { useWidth } from '../../lib/useWidth';
import {
  selectAssessmentFields,
  selectSeedingFields,
  selectHarvestFields,
} from '../../store/automation/automation.selector';
import ReportColumnSection, {
  ReportEntry,
  SEEDING_COLUMNS,
  HARVEST_COLUMNS,
  ASSESSMENT_COLUMNS,
  SPAT_STORAGE_COLUMNS,
  CUSTOM_REPORT_COLUMNS,
} from '../../components/todo/ReportColumnSection';

const ReportTemplatesPage = () => {
  const lang = useSelector(selectLang);
  const width = useWidth();
  const assessmentFields = useSelector(selectAssessmentFields);
  const seedingFields = useSelector(selectSeedingFields);
  const harvestFields = useSelector(selectHarvestFields);

  const [selected, setSelected] = useState<ReportEntry | null>(null);

  const reports: ReportEntry[] = [
    {
      title: '_seeding_report_columns',
      columnKey: 'seeding_report_columns',
      allColumns: [...SEEDING_COLUMNS, ...seedingFields.map(f => f.name)],
      dynamicColumns: seedingFields.map(f => f.name),
    },
    {
      title: '_harvest_report_columns',
      columnKey: 'harvest_report_columns',
      allColumns: [...HARVEST_COLUMNS, ...harvestFields.map(f => f.name)],
      dynamicColumns: harvestFields.map(f => f.name),
    },
    {
      title: '_assess_report_columns',
      columnKey: 'assessment_report_columns',
      allColumns: [...ASSESSMENT_COLUMNS, ...assessmentFields.map(f => f.name)],
      dynamicColumns: assessmentFields.map(f => f.name),
    },
    {
      title: '_spat_storage_report_columns',
      columnKey: 'spat_storage_report_columns',
      allColumns: SPAT_STORAGE_COLUMNS,
    },
    {
      title: '_custom_report_columns',
      columnKey: 'custom_report_columns',
      allColumns: [
        ...CUSTOM_REPORT_COLUMNS,
        ...seedingFields.map(f => f.name),
        ...assessmentFields.map(f => f.name),
        ...harvestFields.map(f => f.name),
      ],
      dynamicGroups: {
        seeding: seedingFields.map(f => f.name),
        assessment: assessmentFields.map(f => f.name),
        harvest: harvestFields.map(f => f.name),
      },
      noTabs: true,
    },
  ];

  return (
    <div className='content pb-32'>
      {width > 768 && (
        <Title
          className='mb-24'
          size={5}
          color='black-3'
          align='default'
          fontWeight={600}
        >
          {translate(lang, 'Report Templates')}
        </Title>
      )}

      {selected ? (
        <ReportColumnSection
          key={selected.columnKey}
          title={selected.title}
          columnKey={selected.columnKey}
          allColumns={selected.allColumns}
          dynamicColumns={selected.dynamicColumns}
          dynamicGroups={selected.dynamicGroups}
          noTabs={selected.noTabs}
          onBack={() => setSelected(null)}
        />
      ) : (
        <div className='card' style={{ maxWidth: 480, width: '100%' }}>
          {reports.map((r, i) => (
            <button
              key={r.columnKey}
              onClick={() => setSelected(r)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                background: 'none',
                border: 'none',
                borderBottom:
                  i < reports.length - 1 ? '1px solid #e8e8e8' : 'none',
                padding: '16px 24px',
                cursor: 'pointer',
                textAlign: 'left',
              }}
              type='button'
            >
              <span style={{ fontSize: 14, fontWeight: 500, color: '#1a1a1a' }}>
                {translate(lang, r.title)}
              </span>
              <ChevronRight />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReportTemplatesPage;
